import { Fragment, memo } from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { SquareStackIcon, TrashIcon } from '@/icons';
import { useQuizList } from '../useQuizList';
import { EditableHint } from './EditableHint';
import { EditTools } from './EditTools';
import { useQuizControl } from './QuizControlProvider';
import { EditableSubjective } from './Subjective';
export const SubjectiveBody = memo(({
  leftSlot
}: {
  leftSlot: React.ReactNode;
}) => {
  const {
    index
  } = useQuizControl();
  const {
    handleCopy,
    handleDelete
  } = useQuizList();
  const {
    t
  } = useTranslation(['common', 'build']);
  const aiGenerateTool = EditTools.useAiGenerateTool();
  return <Fragment>
        <div className="flex flex-row justify-between" onClick={e => e.stopPropagation()}>
          {leftSlot}
          <div className="flex flex-row items-center gap-xs">
            <EditTools.AiGenerateButton />
            <EditTools.QuizDuplicateButton />
            <EditTools.QuizDeleteButton />
            <EditTools.EditToolsDrawer tools={[...(aiGenerateTool ? [aiGenerateTool] : []), {
          icon: <SquareStackIcon size="md" fill={ICON_COLOR.default} />,
          label: String(t('global.duplicate.button')),
          onClick: () => handleCopy(index)
        }, {
          icon: <TrashIcon size="md" fill={ICON_COLOR.default} />,
          label: String(t('global.delete')),
          onClick: () => {
            void handleDelete(index);
          }
        }]} />
          </div>
        </div>

        <div className="flex flex-col justify-between gap-xs" onClick={e => e.stopPropagation()}>
          <EditableSubjective />
          <EditableHint />
        </div>
      </Fragment>;
});